import { useEffect } from 'react';
import { useTheme } from 'next-themes';
import { useAuthState } from '@/hooks/useAuthState';
import { useRef } from 'react';

export const useGlobalThemeLoader = () => {
  const { setTheme } = useTheme();
  const { user, profile } = useAuthState();
  const hasLoadedTheme = useRef(false);

  useEffect(() => {
    // Only load theme once when user first logs in
    if (user && profile?.notification_preferences && !hasLoadedTheme.current) {
      const preferences = profile.notification_preferences as any;
      const savedTheme = preferences?.theme;
      
      console.log('Global theme loader: First load, checking saved theme', { 
        savedTheme, 
        hasUser: !!user, 
        hasProfile: !!profile,
        preferences: profile.notification_preferences
      });
      
      if (savedTheme && typeof savedTheme === 'string') {
        console.log('Global theme loader: Loading saved theme on first login:', savedTheme);
        setTheme(savedTheme);
        hasLoadedTheme.current = true;
      }
    }
  }, [user?.id, profile?.id, setTheme]); // Only depend on IDs to avoid reloading
};